<div class="container-fluid mt-3 g-0 px-3">
    <!-- <button class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getInterventionListFromMockedData()">
  <mat-icon class="material-symbols-outlined">upgrade</mat-icon>
</button> -->
    <div class="row">
        @if (IsDevelopment) {
        <button appPreventDoubleClick class="col-auto" color="primary" mat-icon-button (throttledClick)="reset()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
        }
        <button appPreventDoubleClick class="col" color="accent" mat-raised-button (throttledClick)="getMyIntervention()">
            <mat-icon class="material-symbols-outlined">get_app</mat-icon>
        </button>
    </div>
    @for (int of InterventionList; track int; let i = $index) {
    <div class="col-12 col-md-4 col-xl-2 m-1 ">
        <div class="h-100 m-3">
            <div class="row border rounded-1 background-light" [style.border-left-color]="getColorByInterventionIndex(int.Status)"
                 style="border-width: 2px !important; border-left: 20px solid !important;"
                 (click)="navigatoToIntervention(int.Code, int.SamplingPoint.Name)">
                <!-- <div class="" [style.border-color]="getColorByInterventionIndex(int.Status)" style="max-width: 14px !important;
                                                                                            display: inline-flex;
                                                                                            border: 2px solid;
                                                                                            padding: 0;
                                                                                            border-radius: 2px;">
        <span style="min-width: 10px;" [style.background-color]="getColorByInterventionIndex(int.Status)"></span>
      </div> -->
                <div class="col ms-1 p-1">
                    <!-- <h5 class="card-title">{{s.Portfolio.SamplingPoint.Code}}</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> {{int.SamplingPoint.Name}}</h2>
                    </div>
                    <div class="row">
                        <span class="col text-center"> Intervention {{int.Code}} </span>
                    </div>
                    <div class="row">
                        <span class="col text-center"> Strategie {{int.StrategyId}} </span>
                    </div>
                    <div class="row">
                        <span class="col text-center"> {{int.ClientName}} </span>
                    </div>
                    <div class="row">
                        <span class="col text-center"> Rédacteur {{int.Redactor}} </span>
                    </div>
                    <div class="row">
                        <!-- <span class="col-auto text-start"> </span> -->
                        <!-- </div>
        <div class="row">
          [style.background-color]="getColor()"
          -->
                        <span class="my-2 col text-center"> {{int.SamplingPoint.Address}} {{int.SamplingPoint.ZipCode}} {{int.SamplingPoint.City}}</span>
                    </div>
                    @if (int.HasPose && !int.HasNoZone) {
                    <div class="row border rounded-1 mx-2 py-2 align-items-center " style="background-color: lightsteelblue;">
                        <div class="col-4">
                            <img src="assets/POSE.png" width="50" height="50" />
                        </div>
                        <div class="col-8">
                            <div class="row">
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.StaticPumpWithBatteryPose}}</span>
                                    <mat-icon class="material-symbols-outlined"> battery_charging_full </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.StaticPumpWithPowerSupplyPose}}</span>
                                    <mat-icon class="material-symbols-outlined"> power </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.MeasureForPoseWithFan}}</span>
                                    <mat-icon class="material-symbols-outlined"> wind_power </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.PumpOnOperator}} </span>
                                    <mat-icon class="material-symbols-outlined"> vignette </mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    @if (int.HasDePose) {
                    <div class="row border rounded-1 mx-2 py-2 align-items-center background-orange" style="background-color: lightsteelblue;">
                        <div class="col-4">
                            <img src="assets/DEPOSE.png" width="50" height="50" />
                        </div>
                        <div class="col-8">
                            <div class="row">
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.StaticPumpWithBatteryDepose}}</span>
                                    <mat-icon class="material-symbols-outlined"> battery_charging_full </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.StaticPumpWithPowerSupplyDepose}}</span>
                                    <mat-icon class="material-symbols-outlined"> power </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.MeasureForDeposeWithFan}}</span>
                                    <mat-icon class="material-symbols-outlined"> wind_power </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    @if (int.HasNoZone) {
                    <div class="row border rounded-1 mx-2 py-2 align-items-center background-orange" style="background-color: darkkhaki;">
                        <div class="col-4">
                            <img src="assets/biological-hazard.png" width="50" height="50" />
                        </div>
                        <div class="col-8">
                            <div class="row">
                                <div class="col-6 text-center">
                                </div>
                                <div class="col-6 text-center">
                                    <span style="vertical-align: super">{{int.PumpOnOperator}} </span>
                                    <mat-icon class="material-symbols-outlined"> vignette </mat-icon>
                                </div>
                                <div class="col-6 text-center">
                                </div>
                                <div class="col-6 text-center">
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    @if (int.SituationPlan && int.SituationPlan.Data) {
                    <div class="row m-2 g-1 text-center align-items-center">
                        <span class="col-12 border rounded-1 background-200" style="height: 50px;" (click)="openPlanDeSituation($event, int.SituationPlan.Data)">
                            <div class="row align-items-center h-100">
                                <h3 class="col fw-bold">Plan de Situtation</h3>
                            </div>
                            <!-- <img id="idimage" style="display: none;" class="w-100" [src]="'data:image/jpeg;base64,'+int.SituationPlan.Data" > -->
                        </span>
                    </div>
                    }
                    <div class="row m-2 my-3 g-0">

                        <div class="col pe-1">
                            <button appPreventDoubleClick mat-mini-fab color="primary" class="w-100 mat-elevation-z0"
                                    (throttledClick)="refreshSpecificIntervention($event, int)" [disabled]="loadingTask.IsLoading > 0">
                                <mat-icon class="material-symbols-outlined">
                                    download
                                </mat-icon>
                            </button>
                        </div>
                        <div class="col ">

                            <button appPreventDoubleClick mat-mini-fab color="primary" class="w-100 mat-elevation-z0" (throttledClick)="sync(int, $event)"
                                    [disabled]="loadingTask.IsLoading > 0">
                                <mat-icon class="material-symbols-outlined">
                                    cloud_upload
                                </mat-icon>
                            </button>
                        </div>
                        @if (int.Status !== EInterventionStatus.Done) {
                        <div class="col ps-1">

                            <button appPreventDoubleClick mat-mini-fab color="primary" class="w-100 mat-elevation-z0"
                                    [disabled]="loadingTask.IsLoading > 0"
                                    (throttledClick)="sync(int, $event, true)">
                                <mat-icon class="material-symbols-outlined"> done </mat-icon>
                            </button>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>